import { useMemo } from 'react'
import type { Location } from 'history'
import { useAppSelector } from 'hooks/reduxHooks'
import { isCorporateEventsHostname } from 'corporateEvents/utils/corporateEventsRoutes'

export function useCorporateEventsTransformedLocation(location: Location): Location {
  const hostname = useAppSelector(state => state.system.hostname)
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)

  return useMemo(() => {
    if (!isCorporateEventsHostname(hostname)) return location
    if (location.pathname.includes('/corporate-events/')) return location

    return {
      ...location,
      pathname: `/${regionCode.toLowerCase()}/corporate-events${location.pathname}`,
    }
  }, [location, hostname, regionCode])
}
